import createMuiTheme, {
  ThemeOptions,
} from "@material-ui/core/styles/createMuiTheme";

import { brand, status, link, size } from "./colors";

/**
 * Extending MUI default theme by custom brand, status, link colors.
 * Also adding custom breakpoints.
 * @param options ThemeOptions
 */

const createMyTheme = (options: ThemeOptions) => {
  return createMuiTheme({
    brand,
    status,
    link,
    size,
    ...options,
  });
};

const muiThemeOptions = {
  palette: {
    background: {
      default: "#fafafa",
    },
    primary: {
      main: brand.stormyBlue[80],
    },
    secondary: {
      main: brand.carrotOrange[100],
      contrastText: "#fff",
    },
    text: {
      primary: brand.stormyBlue[100],
    },
  },
  typography: {
    htmlFontSize: 10,
    fontSize: 14,
    h1: {
      fontSize: 37,
      fontWeight: "bold",
      paddingBottom: 4,
    },
    h2: {
      fontSize: 20,
      fontWeight: "bold",
      paddingBottom: 4,
    },
    h3: {
      fontSize: 16,
      fontWeight: "bold",
    },
    h4: {
      fontSize: 14,
      fontWeight: "bold",
    },
    subtitle1: {
      fontSize: 14,
      color: brand.stormyBlue[80],
    },
    subtitle2: {
      fontSize: 13,
      color: brand.stormyBlue[80],
    },
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 13,
    },
    button: {
      fontSize: 13,
    },
    caption: {
      fontSize: 11,
    },
    fontFamily: [
      "AtlasGroteskWeb",
      '"Helvetica"',
      '"Arial"',
      '"Source Sans Pro"',
      "sans-serif",
    ].join(","),
  },
};

export const theme = createMyTheme(muiThemeOptions as any);
